import React from "react";

import GenericUpper from "../../components/generic-upper";
import api from "../../services/api";
import downloadFile from "../../utils/downloadFile";
import { Container } from "react-grid-system";
import { DevolucaoContainer } from "./styles";
import TableWithLabelBlackV2 from "../../components/TableWithLabelBlack/indexV2";
import TextOrStatus from "../../components/textOrStatus";
import IconPenEdit from '../../assets/icons/icon-pen-edit.png';
import Button from "../../components/button/button_v2";
import DotsLoader from "../../components/loader";
import Importacao from "../../components/modal/modalImportacao";
import CardGeral from "../../components/card-geral/index";
import PaginatorV2 from "../../components/paginator/indexV2";
import { notifyApiError } from "../../services/apiError";
import { BodyM, TaglineP } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";

class Devolucao  extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
        devolucao: [],
        limit: 30,
        offSet: 0,
        totalDevolucoes: 0,
        loading: false,
        loadingMore: false,
        hideButton: false,
        result: "",
        result2: "",
        size_screen: window.screen.width,
        importar: false,
        loadingSearch: false
    };

    componentDidMount() {
        window.scrollTo(0, 0);

        setInterval(async()=>{
            this.setState({size_screen: window.screen.width});
        }, 990);
        this.search('', '', 30, 0);
    }

    updateResposta = async (resposta) => {
        if (resposta == 0) {
            this.setState({importar: false})
        }
    }

    updateValues = async (text, estado, search) => {
        if (search == 1) {
            
            if(!text && !estado){
                this.search('', '', 30, 0);
            }else{   
                this.setState({ result2: estado });
                this.setState({ result: text });
                this.search(text, estado, 30, 0);
            }
                
        }else{
            this.setState({result: text});
            this.setState({result2: estado});
        }
    }

    search = async (result, result2, limit, offset) => {
        try {
            this.setState({loadingSearch: true});
            
            const search = result;
            const estado = result2;


            const payload = {
                search,
                estado
            }

            const response = await api.post(`/devolucoes/pesquisa?limit=${limit}&offset=${offset}`, payload);

            this.setState({ 
                devolucao: response.data.data.devolucoes,
                totalDevolucoes: response.data.data.total, 
                loading: false
            });
            
            
            this.setState({loadingSearch: false});
        } catch (error) {
            this.setState({loadingSearch: false});
        }
        
    };

    getDevolucao = async () => {
        try {
            const { limit } = this.state;
            const response = await api.get("/devolucoes?limit=" + limit);
            const devolucao = response.data.data;
            if(devolucao && devolucao.length > 0){
                this.setState({ devolucao, loadingSearch: false, hideButton: false });
            }else{
                this.setState({ loadingSearch: false, hideButton: false });
            }
        } catch (error) {
            this.setState({ loadingSearch: false, hideButton: true });
        }
    };

    cleanFilter = () => {
        this.setState({
            result: "",
            result2: "",
            offSet: 0
        });
        this.search('', '', 30, 0);
    };

    getXlms = async () => {
        this.setState({ loading: true });
        try {
            const payload = {
                search: this.state.result,
                estado: this.state.result2
            };

            const response = await api.post("/relatorios/devolucoes", payload);

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, 'relatorio-devolucoes.xlsx');
            }
            
        } catch (error) {
            notifyApiError(error, "Falha ao gerar relatório de locais de devolução.");
        } finally {
            this.setState({ loading: false });
        }
    };

    loadMore = async () => {
        this.setState({ loadingMore: true, hideButton: true });
        const { devolucao, limit, offSet } = this.state;
        const newOffset = limit + offSet;

        try {
            const response = await api.get(
                "/devolucoes?limit=" + limit + "&offset=" + newOffset
            );
            let newdevolucao = response.data.data;
            const devolucaoConCat = devolucao.concat(newdevolucao);
            this.setState({
                devolucao: devolucaoConCat,
                offSet: newOffset,
                hideButton: false
            });
        } catch (erro) {
            this.setState({
                hideButton: true
            });
        }
        this.setState({ loadingMore: false });
    };

    onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            
            this.search(this.state.result, this.state.result2, 30, 0);
        }
    }

    openAdd = () => {
        this.props.history.push('/devolucoes/add');
    }

    updateLimitOffset = (l,o) => {
        if (l !== this.state.limit || o !== this.state.offset) {
            this.setState({
                limit: l,
                offset: o
            })

            this.search(this.state.result, this.state.result2, l, o);
        }
    }

    render() {
        const { importar, devolucao, loadingSearch, result, size_screen, limit, totalDevolucoes } = this.state;
        return (
            <>
                <GenericUpper
                    title="Locais de Devolução"
                    subtitle="Gerencie seus locais de devolução"
                    search={true}
                    searchFunction={(text, estado, search) => this.updateValues(text, estado, search)}
                    onKeyDown={(e) => this.onKeyDown(e)}
                    estados={true}
                    placeholder="Nome, Endereço ou Cidade"
                    addButton={true}
                    tooltip={"Adicionar"}
                    linkSearch = {'/devolucoes/add'}
                ></GenericUpper>

                <DevolucaoContainer>
                    <Container style={size_screen <= 768 ? {paddingLeft:"0px", paddingRight:"0px", margin: 'auto'} : {}}>
                    {size_screen <= 768 ? (<>
                            {devolucao ? (
                                <CardGeral
                                    titulos={ ["DEVOLUCAO","NOME", "ENDEREÇO","CIDADE","ESTADO"]}
                                    valores={devolucao}
                                />
                            ):(null)}
                            
                            <DotsLoader show={loadingSearch}></DotsLoader>
                            
                            {/* <Paginator 
                                perPage={limit} 
                                total={totalDevolucoes} 
                                onChange={(limit, offset) => this.updateLimitOffset(limit, offset)}
                                totalItens={devolucao.length}
                            /> */}

                            <PaginatorV2
                                perPage={limit} 
                                total={totalDevolucoes} 
                                onChange={(limit, offset) => this.updateLimitOffset(limit, offset)}
                                totalItens={devolucao.length}
                            />

                            <div 
                                className="button-finish" 
                                style={{ 
                                    width: '100%', 
                                    height: '200px',
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    justifyContent: 'space-evenly',
                                    alignItems: 'center', 
                                }}
                            >
                                <Button 
                                    width='87%'
                                    height='50px'
                                    value='ADICIONAR LOCAL DE DEVOLUÇÃO'
                                    outline={false}
                                    disabled={false}
                                    onClick={() => this.openAdd()}
                                    loading={false}
                                />
                                <Button 
                                    width='87%'
                                    height='50px'
                                    value='RELATÓRIO'
                                    outline={!this.state.loading}
                                    disabled={false}
                                    onClick={() => this.getXlms()}
                                    loading={this.state.loading}
                                />
                            </div>

                        </>):(<>
                        <Importacao
                            style={{display: "flex", justifyContent: "center"}}
                            show={importar}
                            onHide={e => {this.setState({importar: false})}}
                            step={1}
                            fields={["nome", "responsavel", "telefone", "celular", "cep", "endereco", "numero", "compendio", "bairro", "cidade", "estado"]}
                            resposta=''
                            update={this.updateResposta}
                            title='Importar Locais de Devolução'
                        ></Importacao>

                        <TableWithLabelBlackV2
                            columns={[
                                {
                                    key: 'nome',
                                    label: 'Nome',
                                    width: '100%',
                                    minWidth: '200px',
                                    maxWidth: "400px",
                                    maxWidthContent: "400px",
                                    enableHorizontalScroll: true,
                                    render: (d) => (
                                        <BodyM color={d.status === 0 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={800}>{d.nome}</BodyM>
                                    )
                                },
                                {
                                    key: 'endereco',
                                    label: 'Endereço',
                                    width: '100%',
                                    minWidth: '180px',
                                    maxWidth: "400px",
                                    maxWidthContent: "400px",
                                    enableHorizontalScroll: true,
                                    render: (d) => (
                                        <TaglineP color={d.status === 0 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={600}>{d.endereco}</TaglineP>
                                    )
                                },
                                {
                                    key: 'cidade',
                                    label: 'Cidade',
                                    width: '100%',
                                    minWidth: '140px',
                                    maxWidth: "150px",
                                    maxWidthContent: "150px",
                                    enableHorizontalScroll: true,
                                    render: (d) => (
                                        <TaglineP color={d.status === 0 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={600}>{d.cidade}</TaglineP>
                                    )
                                },
                                {
                                    key: 'estado',
                                    label: 'Estado',
                                    minWidth: '100px',
                                    render: (d) => (
                                        <div style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '4px 12px',
                                            borderRadius: '10rem',
                                            backgroundColor: d.status !== 0 ? theme.colors.gray.Cinza_2 : theme.colors.disabled.Desabilitado_Medio,
                                            color: '#fff',
                                            fontSize: '11px',
                                            fontWeight: '700',
                                            letterSpacing: '0.5px',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {d.estado}
                                        </div>
                                    )
                                }
                            ]}
                            data={devolucao}
                            showAll={true}
                            serverSide={true}
                            isLoading={loadingSearch}
                            itemsPerPage={devolucao.length || limit}
                            enableDefaultRowNavigation={false}
                            emptyMessage="Nenhum resultado encontrado."
                            actionsColumn={{
                                enabled: true,
                                position: "first",
                                label: "AÇÕES",
                                width: "100%",
                                minWidth: "70px",
                                maxWidth: "100px",
                                justifyContent: "flex-start",
                                buttons: [
                                    {
                                        key: "edit",
                                        icon: IconPenEdit,
                                        iconAlt: "Editar local de devolução",
                                        tooltip: "Editar local de devolução",
                                        ariaLabel: "Editar local de devolução",
                                        onClick: (d) => this.props.history.push(`devolucoes/${d.id}`)
                                    }
                                ]
                            }}
                        />

                        {/* <Paginator 
                            perPage={limit} 
                            total={totalDevolucoes} 
                            onChange={(limit, offset) => this.updateLimitOffset(limit, offset)}
                            totalItens={devolucao.length}
                        /> */}

                        <PaginatorV2
                            perPage={limit} 
                            total={totalDevolucoes} 
                            onChange={(limit, offset) => this.updateLimitOffset(limit, offset)}
                            totalItens={devolucao.length}
                        />

                        <div 
                            className="button-finish" 
                            style={{ 
                                width: '100%', 
                                display: 'flex', 
                                flexDirection: 'row', 
                                justifyContent: 'space-evenly',
                                alignItems: 'center', 
                                marginTop: '40px',
                            }}
                        >
                            <Button 
                                width='25%'
                                height='50px'
                                value='RELATÓRIO'
                                outline={!this.state.loading}
                                disabled={false}
                                onClick={() => this.getXlms()}
                                loading={this.state.loading}
                            />
                        </div>

                        </>)}
                    </Container>
                </DevolucaoContainer>
            </>
        );
    }
}

export default Devolucao;
